module.exports = __webpack_public_path__ + "img/faceclub-web-small.fc578171.png";